import type { FC, ReactNode } from 'react';
import { Box } from '@mui/material';
import { CircularProgress } from 'components/common';

interface LoadingOverlayProps {
  isLoading: boolean;
  title?: string;
  minHeight?: number | string;
  /**
   * Optional custom node rendered as the loading layer. When omitted a centered
   * CircularProgress with `title` is used.
   */
  fallback?: ReactNode;
  children: ReactNode;
}

const LoadingOverlay: FC<LoadingOverlayProps> = ({
  isLoading,
  title = 'Loading...',
  minHeight = 240,
  fallback,
  children,
}) => {
  return (
    <Box sx={{ position: 'relative', minHeight, width: '100%' }}>
      {children}
      {isLoading && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            zIndex: 2,
            borderRadius: 2,
          }}
        >
          {fallback ?? <CircularProgress title={title} />}
        </Box>
      )}
    </Box>
  );
};

export default LoadingOverlay;
